import React, { useEffect, useMemo, useRef } from 'react'
import withAppconfig from '../AppContext'
import SimpleView from './SimpleView'
import HorizontalView from './HorizontalView'
import VerticalView from './VerticalView2'
import FlightView from './FlightView'
import NowAvailable from './NowAvailable'
import moment from 'moment-timezone'
import { freeTimesForDay, getOffset } from './ViewUtils'
const TIMEZONEOFFSET = getOffset('Europe/Helsinki')


const filterVacancies = (vacancies, filters, resourceleadtimes, servertime) => {
  if (!filters && !resourceleadtimes) return vacancies
  if (filters.zenniz) {
    vacancies
      .map((v) => {
        v.courts = v.courts.filter((v) => v.zenniz)
        if (v.courts.length > 0) {
          return v
        } else {
          return null
        }
      })
      .filter((v) => v)
  }
  if(resourceleadtimes) {
    vacancies
      .map((v) => {
          // filter out resources that need more lead time than current time and starttime difference
          const n = moment(servertime).add(Math.abs(TIMEZONEOFFSET), 'minutes')
          v.courts = v.courts.filter((c) => { 
            if (c.id && resourceleadtimes[c.id]) {
              const leadtime = resourceleadtimes[c.id]
              const start = moment.utc(v.start)
              const diff = start.diff(n, 'minutes')
              if (diff >= leadtime) {
                return true
              } else {
                return false
              }
            } else {
              return true
            }
          })
          if (v.courts.length > 0) {
            return v
          } else {
            return null
          }
      })
      .filter((v) => v)
  }

  return vacancies
}

function ReservationCalendar({
  view,
  appconfig,
  servertime,
  selectedCategory,
  onUnreservableClick,
  selectedday,
  vacancies,
  filters
}) {
  // null when the selected day's vacancies have not arrived yet.
  const resolved = useMemo(() => {
    if (!selectedday) return null
    const dateindex = moment.utc(selectedday).format('YYYYMMDD')
    const v = vacancies && vacancies[dateindex]
    if (!v) return null
    return filterVacancies(
      v,
      filters,
      appconfig ? appconfig.resourceleadtimes : null,
      servertime
    )
  }, [vacancies, selectedday, filters, servertime, appconfig])

  // The last committed set, kept so a refresh of the SAME day does not blank the calendar. Never
  // shown for another day: see freeTimesForDay. The ref is only written after commit, so a
  // discarded render cannot poison it.
  const lastCommitted = useRef([])
  useEffect(() => {
    if (resolved) lastCommitted.current = resolved
  }, [resolved])
  const dailyFreeTimes = freeTimesForDay(resolved, lastCommitted.current, selectedday)

  let currentTime = null
  if (selectedday && servertime) {
    if (servertime.format('YYYY-MM-DD') === selectedday) {
      currentTime = servertime.format('HH:00')
    }
  }

  // `view` is resolved by useCalendarView in the owning screen - this component
  // holds no view state of its own.
  const viewProps = {
    dailyFreeTimes,
    currentTime,
    selectedvenue: selectedCategory,
    onUnreservableClick,
    appconfig,
  }

  if (view === 'horizontal') {
    return <HorizontalView {...viewProps} />
  } else if (view === 'vertical') {
    return <VerticalView {...viewProps} />
  } else if (view === 'flight') {
    return <FlightView {...viewProps} />
  } else if (view === 'lastminute') {
    return (
      <NowAvailable
        dailyFreeTimes={[]}
        selectedvenue={selectedCategory}
        weather={null}
        viewEmptyTimes={false}
        showWeek={false}
        appconfig={appconfig}
      />
    )
  }
  // 'simple', plus anything unrecognised (e.g. a stale 'multi' preference) -
  // fail safe to the default view rather than rendering an error string.
  return <SimpleView {...viewProps} />
}

export default withAppconfig(ReservationCalendar)
